// IMP START - Quick Start
import { WEB3AUTH_NETWORK } from "@web3auth/modal";
import { type Web3AuthContextConfig } from "@web3auth/modal/vue";
// IMP END - Quick Start

// IMP START - Dashboard Registration
// const clientId = "BIU8v5gERoSOqiWFFsqRZUE_O9g94iObYVlMg1Rq84sZGDkWGqXG_V-TCYVIWnlLeWHA8iU3FdnUqNZuru7mjtE"; // get from https://dashboard.web3auth.io
// IMP END - Dashboard Registration
const clientId = "BG5RlaP5jtLvibzdXSww7UxWCmiII7uLFv2ZO3PTOljT6GJGCEHQHRCdLs-hENOfAm-jpsDHF8HFY6oYOhMO5Jc"; 
// IMP START - Config
const web3AuthContextConfig: Web3AuthContextConfig = {
  web3AuthOptions: {
    clientId,
    web3AuthNetwork: WEB3AUTH_NETWORK.SAPPHIRE_DEVNET,
  }
};
// IMP END - Config

export default web3AuthContextConfig;